import { GraphQLResult, graphqlOperation } from "@aws-amplify/api-graphql";
import { generateClient } from "aws-amplify/api";
import { GetBuildPriceQuery, GetBuildPriceQueryVariables } from "graphql/API";
import { getBuildPrice as getBuildPriceQuery } from "graphql/queries";

export const getBuildPrice = async (
  year: number | undefined
): Promise<GetBuildPriceQuery | undefined> => {
  if (year) {
    const client = generateClient();
    const buildPriceData = (await client.graphql({
      ...graphqlOperation(getBuildPriceQuery, {
        year
      } as GetBuildPriceQueryVariables),
      authMode: "userPool"
    })) as GraphQLResult<GetBuildPriceQuery>;

    return buildPriceData.data;
  }
};
